import { useEffect } from 'react';

/**
 * A React hook that disables scrolling on the body element when a component
 * mounts, and re-enables it when the component unmounts.
 */
export function usePreventBodyScrollByShow(show) {
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;

    if (show) {
      if (typeof window === 'undefined') return;
      document.body.style.overflow = 'hidden';
    }

    return () => (document.body.style.overflow = originalStyle);
  }, [show]);
}

/**
 * A React hook that disables scrolling on the body element when a component
 * mounts, and re-enables it when the component unmounts.
 */
export function usePreventBodyScroll() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = 'hidden';
    document.body.classList.add('body-open-modal');
    document.getElementById('page').setAttribute('aria-hidden', true);

    return () => {
      document.body.style.overflow = originalStyle;
      document.getElementById('page').removeAttribute('aria-hidden');
    };
  }, []);
}
